(function () {
	const els = document.querySelectorAll(`.tablepress, .table, .entry-mobile-toc`);
	if (els.length === 0) {
		return;
	}

	function Table(el) {
		const open_el = el.querySelector(`.btn-more`);
		if (!open_el) {
			return;
		}

		const close_el = el.querySelector(`.btn-less`);
		if (!close_el) {
			return;
		}

		function open() {
			el.classList.add(`show-all`);
		}

		function close() {
			el.classList.remove(`show-all`);
		}

		open_el.addEventListener(`click`, open);

		close_el.addEventListener(`click`, close);
	}

	for (let i = 0; i < els.length; i++) {
		new Table(els[i]);
	}
})();
